/**
 * The CORS proxy Merkle Lens runs for its own site. It forwards only to known CT log hosts and
 * accepts requests only from pages served at merklens.app, so it is offered nowhere else (a copy of
 * the site on another host would get "Access-Control-Allow-Origin: null" back). The address is not
 * shown in the UI; users who want their own proxy enter a URL instead.
 */
export const BUILTIN_PROXY = { url: 'https://cors.merklens.app/', origins: ['https://merklens.app'] };

export function builtinProxyAvailable(): boolean {
  return typeof location !== 'undefined' && BUILTIN_PROXY.origins.includes(location.origin);
}
